import firebase from "firebase/app"
import 'firebase/firestore'


const firebaseConfig = {
    apiKey: 'AIzaSyDfH598Bv_C5kHjxUrzdAxVrQiqEuhxhqs',
    authDomain: "cnx-mission-control.firebaseapp.com",
    projectId: "cnx-mission-control",
    storageBucket: "cnx-mission-control.appspot.com",
    messagingSenderId: "413123276788",
    appId: "1:413123276788:web:5c44f9b8ba244ac0a4d3a1",
    measurementId: "G-L5S3CTD87E"
  };

// Initialize Firebase
firebase.initializeApp(firebaseConfig)

//firebase.analytics()

// Hi

export default firebase
